export default {"src":"/_next/static/media/social-warpcast.8f2ad757.svg","height":155,"width":169,"blurWidth":0,"blurHeight":0};